/**
 * Orçamento de retries por janela temporal e classe.
 */

import type { RetryClass } from './retryClassifier';

const WINDOW_MS = 60_000;
const BUDGET: Record<RetryClass, number> = {
  critical: 200,
  medium: 80,
  low: 50,
};

const windowStart = Date.now();
const counts = new Map<RetryClass, number>();

function resetIfNeeded(now: number): void {
  if (now - windowStart > WINDOW_MS) {
    counts.clear();
  }
}

export function canSpendRetryBudget(retryClass: RetryClass, now: number): boolean {
  resetIfNeeded(now);
  const used = counts.get(retryClass) ?? 0;
  return used < BUDGET[retryClass];
}

export function spendRetryBudget(retryClass: RetryClass): void {
  counts.set(retryClass, (counts.get(retryClass) ?? 0) + 1);
}

export function _testResetRetryBudget(): void {
  counts.clear();
}
